import React from "react";

export const Footer = (props) => {
  const contact = props.contact || {};
  const onHomeClick = (e) => {
    if (props.onHome) {
      e.preventDefault();
      props.onHome();
    }
  };

  return (
    <footer id="site-footer" className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col footer-brand-col">
            <a
              href="#page-top"
              className="footer-brand"
              onClick={onHomeClick}
              aria-label="GOLDLY AI home"
            >
              <img
                src="img/logo/logo-trim.png"
                alt="GOLDLY AI"
                className="footer-logo"
              />
            </a>
            <p className="footer-tagline">
              Enterprise AI agents for global business — powered by a unified
              LLM gateway and multi-cloud infrastructure.
            </p>
            <div className="footer-social">
              <a
                href={contact.whatsappQr || "img/contact/whatsapp-qr.jpg"}
                className="footer-social-whatsapp"
                aria-label="WhatsApp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-whatsapp" />
                <span className="footer-whatsapp-qr" aria-hidden="true">
                  <img
                    src={contact.whatsappQr || "img/contact/whatsapp-qr.jpg"}
                    alt=""
                  />
                </span>
              </a>
              <a
                href={
                  contact.linkedin ||
                  "https://www.linkedin.com/in/goldlyfranksun"
                }
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-linkedin" />
              </a>
              <a
                href={
                  contact.telegram
                    ? `https://t.me/${contact.telegram.replace("@", "")}`
                    : "https://t.me/xfrank404"
                }
                aria-label="Telegram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-paper-plane" />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Products</h4>
            <ul className="footer-list">
              <li>
                <a
                  href="https://tokenshengsheng.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shengsheng Token
                </a>
              </li>
              <li>
                <a
                  href="https://tokenwenwen.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Wenwen Token
                </a>
              </li>
              <li>
                <a
                  href="https://pandasrouter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PandasRouter
                </a>
              </li>
              <li>
                <a
                  href="https://shiyeagent.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shiye Agent
                </a>
              </li>
              <li>
                <a
                  href="https://agent.thinkloop.me"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Super Agent
                </a>
              </li>
              <li>
                <a
                  href="https://aisport.one"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AI Sport
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-list">
              <li>
                <a href="#agents" onClick={onHomeClick}>
                  Enterprise Agents
                </a>
              </li>
              <li>
                <a href="#features" onClick={onHomeClick}>
                  Why Us
                </a>
              </li>
              <li>
                <a href="#about" onClick={onHomeClick}>
                  About
                </a>
              </li>
              <li>
                <a href="#services" onClick={onHomeClick}>
                  Business
                </a>
              </li>
              <li>
                <a href="#portfolio" onClick={onHomeClick}>
                  Products
                </a>
              </li>
              <li>
                <a href="#testimonials" onClick={onHomeClick}>
                  Customer Cases
                </a>
              </li>
              <li>
                <a href="#team" onClick={onHomeClick}>
                  Global Presence
                </a>
              </li>
              <li>
                <a href="#contact" onClick={onHomeClick}>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-list footer-contact">
              <li>
                <i className="fa fa-map-marker" />
                <span>
                  {contact.address ||
                    "135 MIDDLE ROAD, #02-16, BYLANDS BUILDING, SINGAPORE 188975"}
                </span>
              </li>
              <li>
                <i className="fa fa-globe" />
                <a
                  href="https://goldly.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  goldly.ai
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            © 2026 CLOUD GOLD PTE. LTD. (UEN: 202606352W). "Goldly AI" is our
            brand. All rights reserved.
          </p>
          <ul className="footer-legal">
            <li>
              <a
                href="https://goldly.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy
              </a>
            </li>
            <li>
              <a
                href="https://goldly.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms
              </a>
            </li>
            <li>
              <a
                href="https://goldly.ai"
                target="_blank"
                rel="noopener noreferrer"
              >
                Security
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
